import { MainColor } from '../../palette';

export const getPopperThemeConfig = () => {
  return {
    popper: {
      tooltipBackgroundColor: 'coolGrey60' as MainColor,
      textColor: 'white100' as MainColor,
      textColorTransparentBG: 'coolGrey60' as MainColor,
      activeBackgroundElement: 'navy10' as MainColor,
    },
  };
};

export type PopperThemeConfig = ReturnType<typeof getPopperThemeConfig>;
